export const createRecordingMutation = /* GraphQL */ `
  mutation createRecording($recording: RecordingInput!) {
    createRecording(recording: $recording) {
      uploadUrl
    }
  }
`;
